import { ComponentType } from 'react';

import { Element, Processor } from '@/features/html2react/types';

import Fill from '../components/fill';

interface FillElement extends Element {
  props: Element['props'] & {
    slot: string;
    'data-fill-slot': string;
  };
}

const fill: Processor<FillElement> = {
  priority: 10,
  name: 'fill',
  test: ({ node }) =>
    node.props?.hasOwnProperty('data-fill-slot') &&
    !!node.props?.className &&
    node.props.className.includes('wp-block-erom-fill'),
  processor: ({ node }) => {
    node.props.slot = node.props['data-fill-slot'];
    node.component = Fill as ComponentType;

    return node;
  }
};

export default fill;
